module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div class=\"title\">\n    <h1>Flight Statistics</h1>\n  </div>\n  <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 693
// module chunks = 0